import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-mode-wrapper" }
const _hoisted_2 = { class: "edit-mode-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      "uk-icon": "icon: create-new-folder-big",
      class: "create-folder-button uk-margin-small-right",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createFolderClicked')))
    }),
    _createElementVNode("span", {
      class: "edit-mode-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('switchEditModeClicked')))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("span", {
        "uk-icon": "icon: pencil; ratio: 1.3;",
        class: "edit-mode-button-icon"
      }, null, -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.editMode ? 'on' : 'off'), 1)
    ])
  ]))
}